import React from 'react';

export const IconUnChecked = () => {
    return (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="1.33594" width="13" height="13" rx="1.5" fill="white" fillOpacity="0.5" stroke="#CCCCCC"/>
        </svg>
    );
};
